// Components
// Types
import Comments from 'components/Comments';
import type { TMemberType } from '@timeedit/types/lib/types';
import GeneralInfo from './sections/GeneralInfo';
import ObjectTypeHierarchy from './sections/ObjectTypeHierarchy';

interface Props {
  membership?: TMemberType;
  onChange: (key: string, value: any) => void;
}

const Membership = ({ membership, onChange }: Props) => {
  if (!membership) return null;
  return (
    <>
      <GeneralInfo membership={membership} onChange={onChange} />
      <ObjectTypeHierarchy membership={membership} onChange={onChange} />
      <Comments
        value={membership?.description || ''}
        onChange={(value) => onChange('description', value)}
      />
    </>
  );
};

export default Membership;
